import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Table, Spinner, Accordion, Card, Dropdown, Badge, Modal, DropdownButton } from 'react-bootstrap'
import Loader from '../../Helper/Loader';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
function New(props) {

  return (
    <>
      <Modal className="Category-new-modal" show={props.getEditShow} onHide={props.handleCloseEdit} animation={false}>
        {/* <Modal.Header closeButton>
          <Modal.Title>Update Category</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>

          <IconButton
            style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px', zIndex: 111 }}
            onClick={props.handleCloseEdit}
          >
            <CloseIcon className="Header-close-modal-icon" />
          </IconButton>
          <div className="row">
            <div className="col-md-12">
              <h5 style={{ textAlign: 'center', padding: '10px' }}>Update Category</h5>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Category Name</label>
                <input type="text" className="form-control" value={props.getTitle}
                  onChange={(e) => props.setTitle(e.target.value)} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label>Icon URL</label>
                <input type="text" className="form-control" value={props.getIconUrl}
                  onChange={(e) => props.setIconUrl(e.target.value)} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label>Category Slug</label>
                <textarea className="form-control"
                  onChange={(e) => props.setSubTitle(e.target.value)} >{props.getSubTitle}</textarea>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <Button
                  style={{ background: '#2c2245cf', color: '#f7f7f7' }}
                  color="info"
                  variant="contained"
                  size="medium"
                  onClick={() => !props.updateresult.isLoading && props.updatePost(props.categoryData)}>
                  {props.updateresult.isLoading ? <Loader /> : 'Update'}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default New;
